// Display-only cleanup of chain recommendation titles.
//
// Local/test-data experiences carry lineage markers baked into the title, e.g.
// "Spiced Maple Candied Bacon (Product Master) #569 — Instance" or
// "Spiced Pumpkin Praline Roll (Instance 1) — Instance". These are noise for a
// viewer; strip them at render time only (DB untouched). Scoped to the exact
// lineage tokens so it never touches a legitimate parenthetical (e.g. a real
// "(Gluten Free)"), and it's a no-op on clean production titles.

const LINEAGE = "Product Master|Master Instance|Master|Instance"; // longest-first for the alternation

export function cleanChainTitle<T>(title: T): T | string {
  if (!title || typeof title !== "string") {
    return title;
  }
  const cleaned = title
    // parenthetical lineage marker, optionally numbered ("(Instance 1)"), plus
    // any catalogue id "#569" that trails it — kept adjacent to the marker so a
    // legitimate standalone "#12" elsewhere in a real title is left alone.
    .replace(
      new RegExp(`\\((?:${LINEAGE})(?:\\s+\\d+)?\\)(?:\\s*#\\d+)?`, "gi"),
      "",
    )
    // test-source markers
    .replace(/\(Google\)/gi, "")
    // em-dash lineage suffix: "— Instance", "— Master Instance", ...
    .replace(new RegExp(`\\s*—\\s*(?:${LINEAGE})\\b`, "gi"), "")
    // hyphen "- Recipe" suffix
    .replace(/\s*-\s*Recipe\b/gi, "")
    .replace(/\s{2,}/g, " ")
    .trim()
    // drop any separator left dangling at the end
    .replace(/[\s—,-]+$/, "")
    .trim();
  // Never return an empty string — fall back to the original.
  return cleaned || title;
}
